export type SwitchListVariant = 'toggle' | 'on-off';

export type SwitchListItem = {
  label: string;
  value: unknown;
  meta?: Record<string, unknown>;
};

export type OnOffEntity<TIdKey extends string = 'id'> = {
  action: 'allow' | 'block';
} & Record<TIdKey, string>;

export type OnOffAction = 'allow' | 'block';

export const getEntityValue = <TIdKey extends string>(
  entities: OnOffEntity<TIdKey>[] | undefined,
  optValue: string,
  idField: TIdKey
): OnOffAction | undefined => {
  if (!entities?.length) {
    return undefined;
  }
  const entity = entities.find((entity) => entity[idField] === optValue);
  return entity?.action;
};

export const updateEntities = <TIdKey extends string>(
  entities: OnOffEntity<TIdKey>[] | undefined,
  idField: TIdKey,
  optValue: string,
  action: OnOffAction | undefined
): OnOffEntity<TIdKey>[] => {
  const current = entities ?? [];
  const existingIndex = current.findIndex((entity) => entity[idField] === optValue);

  if (action === undefined) {
    if (existingIndex === -1) {
      return current;
    }
    const updated = [...current];
    updated.splice(existingIndex, 1);
    return updated;
  }

  const newEntity = { [idField]: optValue, action } as OnOffEntity<TIdKey>;
  if (existingIndex === -1) {
    return [...current, newEntity];
  }
  const updated = [...current];
  updated[existingIndex] = newEntity;
  return updated;
};
